import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdditionalServices = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M19 28a1 1 0 0 1-1 1h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1Zm-3-14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm11.952 5.479-1.545 6.954a2 2 0 0 1-3.188 1.138l-3.405-2.57h-7.625L8.78 27.57a2 2 0 0 1-3.189-1.138l-1.545-6.954a2.01 2.01 0 0 1 .415-1.714l3.57-4.282c.12-1.574.481-3.12 1.072-4.584 1.612-4.043 4.5-6.579 5.67-7.481a2 2 0 0 1 2.45 0c1.168.902 4.06 3.438 5.672 7.48a15.4 15.4 0 0 1 1.071 4.585l3.57 4.282a2.011 2.011 0 0 1 .415 1.714ZM12.43 23h7.142c2.64-4.692 3.134-9.185 1.468-13.36C19.57 5.955 16.812 3.625 16 3c-.813.625-3.57 2.955-5.04 6.64-1.664 4.175-1.17 8.668 1.47 13.36Zm-1.875.731c-1.346-2.446-2.163-4.85-2.45-7.21L6 19.044 7.545 26l.022-.016 2.987-2.253ZM26 19.045l-2.104-2.525c-.285 2.357-1.1 4.76-2.445 7.211l2.981 2.25.023.017L26 19.045Z" })
});
export default SvgAdditionalServices;
